import { render, staticRenderFns } from "./loginRoleDialog.vue?vue&type=template&id=b0a18100&scoped=true"
import script from "./loginRoleDialog.vue?vue&type=script&lang=js"
export * from "./loginRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./loginRoleDialog.vue?vue&type=style&index=0&id=b0a18100&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a18100",
  null
  
)

export default component.exports